import { useMutation, useQueryClient } from '@tanstack/react-query';
import noop from 'lodash-es/noop';

import type { UseCartProductParams } from '@jane/shared-ecomm/data-access';
import {
  removeCartProduct,
  updateCartProducts,
  useOptimizeSpecials,
} from '@jane/shared-ecomm/data-access';

import { getLocalCartUuid } from '../localCartUuid/localCartUuid';

export const useRemoveCartProduct = ({
  onSuccess = noop,
  onError = noop,
}: UseCartProductParams) => {
  const { mutate: optimizeSpecials } = useOptimizeSpecials();
  const cartUuid = getLocalCartUuid();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeCartProduct,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });

      if (cartUuid) {
        optimizeSpecials({
          app_mode: 'kiosk',
          reservation_mode: 'kiosk',
          uuid: cartUuid,
          promo_code: undefined,
          user_group_special_id: undefined,
        });
      }

      onSuccess();
    },
  });
};

export const useUpdateCartProduct = ({
  onSuccess = noop,
  onError = noop,
}: UseCartProductParams) => {
  const { mutate: optimizeSpecials } = useOptimizeSpecials();
  const cartUuid = getLocalCartUuid();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCartProducts,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });

      if (cartUuid) {
        optimizeSpecials({
          app_mode: 'kiosk',
          reservation_mode: 'kiosk',
          uuid: cartUuid,
          promo_code: undefined,
          user_group_special_id: undefined,
        });
      }

      onSuccess();
    },
  });
};
